import type { LinkItem } from "../types/content";
import { profile } from "./profile";

export const socialLinks: LinkItem[] = [
  {
    label: "LinkedIn",
    href: profile.linkedin,
    external: true,
  },
  {
    label: "GitHub",
    href: profile.github,
    external: true,
  },
  {
    label: "Request CV",
    href: profile.cvRequestUrl,
  },
];
